import script from "./OverviewCard.vue?vue&type=script&setup=true&lang=js"
export * from "./OverviewCard.vue?vue&type=script&setup=true&lang=js"

import "./OverviewCard.vue?vue&type=style&index=0&id=26a48aa8&lang=css"
import "./OverviewCard.vue?vue&type=style&index=1&id=26a48aa8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26a48aa8"]])

export default __exports__